import script from "./WHeaderAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./WHeaderAuth.vue?vue&type=script&setup=true&lang=ts"

import "./WHeaderAuth.vue?vue&type=style&index=0&id=14ce7a40&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ce7a40"]])

export default __exports__